import { ThemeContext } from "styled-components";
import { useContext } from "react";
import { getColor } from "../../theme";
var useColor = function () {
    var theme = useContext(ThemeContext);
    var pickColor = function (color) { return getColor(color)({ theme: theme }); };
    return pickColor;
};
export default useColor;
